import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import { API_ROUTES, API_DOMAIN, headers } from '../../../Reusable_Components/Config/apiConfig';
import FormComponent from '../../../Reusable_Components/FormComponent';

const OpportunityActivityInput = () => {
  const { activityId = '' } = useParams();
  const decodedId = activityId ? atob(activityId) : activityId;
  const id = decodedId.replace(/\D/g, '');
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({});
  const route = 'opportunityActivity';

  useEffect(() => {
    if (activityId) {
      setIsEditing(true);
      fetchActivityDetails();
    }
  }, [activityId]); // eslint-disable-line react-hooks/exhaustive-deps

  const fetchActivityDetails = async () => {
    try {
      const response = await axios.get(`${API_DOMAIN}${API_ROUTES.opportunityActivity}${id}/`, { headers });
      setFormData(response.data?.data ?? response.data);
    } catch (error) {
      console.error('Error fetching activity details:', error);
    }
  };

  const activityFields = [
    {
      name: 'opportunity', label: 'Opportunity', type: 'async-select', required: true,
      endpoint: API_ROUTES.opportunity,
      getOptionLabel: (o) => o.opportunity_name,
    },
    {
      name: 'activity_type', label: 'Activity Type', type: 'select',
      options: [
        { value: 'call', label: 'Call' },
        { value: 'email', label: 'Email' },
        { value: 'meeting', label: 'Meeting' },
        { value: 'demo', label: 'Demo' },
        { value: 'follow_up', label: 'Follow-up' },
        { value: 'proposal_sent', label: 'Proposal Sent' },
        { value: 'negotiation', label: 'Negotiation' },
        { value: 'other', label: 'Other' },
      ],
    },
    { name: 'date', label: 'Date', type: 'date', required: true },
    { name: 'time', label: 'Time', type: 'time', required: true },
    { name: 'duration_minutes', label: 'Duration (minutes)', type: 'number' },
    { name: 'description', label: 'Description', type: 'textarea', required: true },
    {
      name: 'outcome', label: 'Outcome', type: 'select',
      options: [
        { value: '', label: '— Select Outcome —' },
        { value: 'positive', label: 'Positive' },
        { value: 'neutral', label: 'Neutral' },
        { value: 'negative', label: 'Negative' },
        { value: 'no_answer', label: 'No Answer' },
        { value: 'pending', label: 'Pending' },
      ],
    },
    { name: 'outcome_notes', label: 'Outcome Notes', type: 'textarea' },
    { name: 'follow_up_required', label: 'Follow-up Required', type: 'checkbox' },
    { name: 'follow_up_date', label: 'Follow-up Date', type: 'date', dateConstraint: 'future' },
    {
      name: 'assigned_to', label: 'Assigned To', type: 'async-select',
      endpoint: API_ROUTES.users,
      getOptionLabel: (u) => u.username,
    },
  ];

  return (
    <div>
      <h1>{isEditing ? 'Edit Opportunity Activity' : 'Create Opportunity Activity'}</h1>
      <FormComponent fields={activityFields} initialFormData={formData} route={route} />
    </div>
  );
};

export default OpportunityActivityInput;
